module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/dzlogo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("帐号激活")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06c7df54!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pc/header.vue
// module id = 191
// module chunks = 0